// extracted by mini-css-extract-plugin
module.exports = {"container":"uploadLocalFileField_container__CcQwP","buttonContainer":"uploadLocalFileField_buttonContainer__2kLBq","textContainer":"uploadLocalFileField_textContainer__19Hb6"};